(()=>{
  const init=(root=document)=>{
    root.querySelectorAll('[data-pn-product]').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const form=section.querySelector('form[data-pn-form]');
      const input=form?.querySelector('[name="id"]');
      const submit=form?.querySelector('[type="submit"]');
      const submitLabel=submit?.querySelector('[data-pn-label]');
      const submitAmounts=submit?.querySelector('[data-pn-amounts]');
      const currentPrice=section.querySelector('[data-pn-price]');
      const currentCompare=section.querySelector('[data-pn-compare]');
      const selectOffer=button=>{
        const hasVariant=Boolean(button.dataset.variant);
        const available=hasVariant&&button.dataset.available==='true';
        section.querySelectorAll('[data-pn-bundle]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        if(input){input.value=button.dataset.variant||'';input.disabled=!available;}
        if(submit){submit.disabled=!available;submit.removeAttribute('aria-busy');}
        if(submitLabel)submitLabel.textContent=available?submit.dataset.label:(hasVariant?section.dataset.soldout:section.dataset.unavailable);
        if(submitAmounts)submitAmounts.hidden=!available;
        if(currentPrice)currentPrice.textContent=button.dataset.price;
        if(currentCompare){currentCompare.textContent=button.dataset.compare||'';currentCompare.hidden=!button.dataset.compare;}
        const status=section.querySelector('[data-pn-status]');
        if(status)status.textContent=!hasVariant&&section.dataset.designMode==='true'?section.dataset.mappingNote:'';
      };
      section.querySelectorAll('[data-pn-bundle]').forEach(button=>button.addEventListener('click',()=>selectOffer(button)));
      const selectedOffer=section.querySelector('[data-pn-bundle][aria-pressed="true"]');
      if(selectedOffer)selectOffer(selectedOffer);else if(input)input.disabled=Boolean(submit?.disabled);
      const viewport=section.querySelector('.pn-gallery-viewport');
      const dots=Array.from(section.querySelectorAll('[data-pn-dot]'));
      if(viewport&&dots.length>1){
        const goTo=index=>{
          const bounded=Math.max(0,Math.min(index,dots.length-1));
          const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          viewport.scrollTo({left:bounded*viewport.clientWidth,behavior:reduced?'auto':'smooth'});
        };
        const currentIndex=()=>Math.max(0,Math.min(Math.round(viewport.scrollLeft/viewport.clientWidth),dots.length-1));
        const syncDots=()=>{
          const active=currentIndex();
          dots.forEach((dot,index)=>dot.setAttribute('aria-pressed',String(index===active)));
        };
        dots.forEach((dot,index)=>dot.addEventListener('click',()=>goTo(index)));
        viewport.addEventListener('scroll',syncDots,{passive:true});
        viewport.addEventListener('keydown',event=>{
          if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
            event.preventDefault();
            goTo(currentIndex()+(event.key==='ArrowRight'?1:-1));
          }
        });
        viewport.addEventListener('dragstart',event=>event.preventDefault());
        let drag=null;
        viewport.addEventListener('pointerdown',event=>{
          if(event.pointerType!=='mouse'||event.button!==0)return;
          drag={id:event.pointerId,x:event.clientX,left:viewport.scrollLeft};
          viewport.classList.add('is-dragging');
          viewport.setPointerCapture(event.pointerId);
        });
        viewport.addEventListener('pointermove',event=>{
          if(!drag||event.pointerId!==drag.id)return;
          viewport.scrollLeft=drag.left-(event.clientX-drag.x);
        });
        const finishDrag=event=>{
          if(!drag||event.pointerId!==drag.id)return;
          drag=null;
          viewport.classList.remove('is-dragging');
          goTo(currentIndex());
        };
        viewport.addEventListener('pointerup',finishDrag);
        viewport.addEventListener('pointercancel',finishDrag);
      }
      if(form)form.addEventListener('submit',event=>{if(!input?.value||input.disabled||submit?.disabled){event.preventDefault();return;}if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}});
    });
  };
  document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:block:select',e=>{const block=e.target;if(block.matches('[data-pn-slide]')){const s=block.closest('[data-pn-product]');s?.querySelector(`[data-pn-dot="${block.dataset.pnSlide}"]`)?.click();}if(block.matches('[data-pn-bundle]'))block.click();});
  window.addEventListener('pageshow',()=>document.querySelectorAll('[data-pn-bundle][aria-pressed="true"]').forEach(b=>b.click()));
})();
